<template lang="pug">
    tr

        // Date created
        td {{ item.commentedAt | formattedDate }}

        // User Name
        td {{ item.fullName }}

        // Comment text
        td {{ item.comment }}

        // Rating
        td {{ item.rating }}

</template>

<script>
    import VueTypes from 'vue-types';
    import formattedDate from '~filters/FormattedDate';

    export default {
        props: {
            item: VueTypes.object.def({})
        },
        filters: {
            formattedDate
        }
    };
</script>
